export default __webpack_public_path__ + "static/low-poly-pattern-7cc398fffcda3e8c2ee170b051becf84.png";